module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', [_c('md-input-container', [_c('label', [_vm._v("Postcode")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.selectedPostcode),
      callback: function($$v) {
        _vm.selectedPostcode = $$v
      },
      expression: "selectedPostcode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [(_vm.currentView === 'map') ? _c('div', [_c('GoogleMap', {
    ref: "gmap",
    attrs: {
      "id": "gmap"
    }
  })], 1) : (_vm.currentView === 'query') ? _c('div', [_c('SparqlConsole', {
    attrs: {
      "id": "console"
    },
    on: {
      "runQuery": _vm.runQuery
    }
  })], 1) : _c('div', [_c('ResultView', {
    attrs: {
      "id": "result"
    }
  })], 1)]), _vm._v(" "), _c('md-bottom-bar', [_c('md-bottom-bar-item', {
    attrs: {
      "md-icon": "map",
      "id": "map-button",
      "md-active": ""
    },
    on: {
      "click": function($event) {
        _vm.currentView = 'map'
      }
    }
  }, [_vm._v("Map")]), _vm._v(" "), _c('md-bottom-bar-item', {
    attrs: {
      "md-icon": "code",
      "id": "query-button"
    },
    on: {
      "click": function($event) {
        _vm.currentView = 'query'
      }
    }
  }, [_vm._v("Query")]), _vm._v(" "), _c('md-bottom-bar-item', {
    attrs: {
      "md-icon": "equalizer",
      "id": "result-button"
    },
    on: {
      "click": _vm.runQuery
    }
  }, [_vm._v("Result")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67ca3ec2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 158
// module chunks = 1